import React from "react";
import { Quote } from "lucide-react";

const ITEMS = [
  {
    quote:
      "We bring 500+ learners through our Bengaluru campus every cohort, and lunch is a non-negotiable part of their day. The Office Meal Co. has kept the menu varied, the timing tight, and the dietary tracks honest — Jain, vegan, halal, all flagged clearly.",
    company: "Scaler School of Technology",
    team: "Campus Operations",
  },
  {
    quote:
      "Across four of our co-working hubs, they run our pantry, snacks and barista counters end-to-end. Members notice. Tea and coffee feel like a small thing until somebody quietly does it really well — and they have, every week.",
    company: "91Springboard",
    team: "Workplace Experience",
  },
  {
    quote:
      "Our daily meal programme runs across our managed workspaces in Bengaluru, and the team here genuinely looks forward to lunch — which says everything. Rotating menus, clean labelling, hot food delivered on the dot. It has quietly become one of the most-loved parts of our member experience.",
    company: "Clayworks",
    team: "Member Experience",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-28 md:py-36 bg-[#E8DDCB]/50 paper-grain"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl">
          <p className="label-eyebrow">08 · In Their Words</p>
          <h2 className="font-serif text-[#1E3A5F] mt-5 text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
            Kind things said
            <span className="italic text-[#CBA365]"> over second helpings.</span>
          </h2>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {ITEMS.map((t, idx) => (
            <figure
              key={idx}
              data-testid={`testimonial-${idx}`}
              className={`relative bg-[#FDFBF7] border border-[#1E3A5F]/10 p-8 md:p-10 ${
                idx === 1 ? "md:mt-10" : ""
              }`}
            >
              <Quote
                size={28}
                className="text-[#CBA365]"
                strokeWidth={1.25}
              />
              <blockquote className="mt-5 font-serif text-[#1E3A5F] text-xl md:text-2xl leading-snug">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-[#1E3A5F]/15">
                <div
                  data-testid={`testimonial-${idx}-company`}
                  className="font-serif text-[#1E3A5F] text-xl md:text-2xl leading-tight"
                >
                  {t.company}
                </div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#64748B] mt-2">
                  {t.team}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
